module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Fog-45f797626a909788f5d2910bdfee49b9.svg";